import AuthToken from "../auth-token.tsx";
import { MDXSection } from "./snippets";
import { StatusDiagram } from "./status-diagram";

You can use the [OpenAI Node.js client](https://www.npmjs.com/package/openai) to run **{props.runnableName}** on Replicate.

```jsx
const openai = new OpenAI({
    baseURL: 'https://openai-proxy.replicate.com/v1',
    apiKey: process.env.REPLICATE_API_TOKEN,
});

const output = await openai.chat.completions.create({
  model: "{{ runnableName }}",
  messages: [
    { role: "system", content: "You are a helpful assistant." },
    { role: "user", content: "What is the capital of the moon?" },
  ],
});
console.log(output.choices[0].message.content);
```

<ol className="not-prose">
  <li>Set `base_url` to `https://openai-proxy.replicate.com/v1`</li>
  <li>Set `api_key` to your `REPLICATE_API_TOKEN` environment variable</li>
  <li>Set `model` to <code>{ props.runnableName }</code></li>
</ol>

You can learn about pricing for this model on the <a href={route("model_detail", { name: props.version._extras.model.name, username: props.version._extras.model.owner })}>model page</a>.
